import { render, staticRenderFns } from "./curtainPage.vue?vue&type=template&id=b1d35f54&scoped=true&"
import script from "./curtainPage.vue?vue&type=script&lang=js&"
export * from "./curtainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d35f54",
  null
  
)

export default component.exports